module.exports = __webpack_public_path__ + "img/laba.f66841bd.gif";